function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2776 13.6752C14.3605 15.2514 13.5871 16.5806 13.408 18H10.604C10.4246 16.5806 9.64947 15.2514 8.73034 13.6751C7.09356 10.8681 5 7.27775 5 1H19C19 7.27779 16.9109 10.8682 15.2776 13.6752ZM6.873 12.439C6.576 11.887 6.277 11.294 5.991 10.656C3.076 9.134 1.954 6.406 1.527 4.405H4.216C4.157 3.955 4.113 3.482 4.077 3H0C0.372 7.105 2.808 11.091 6.873 12.439ZM16 23V21.619C14.002 21.619 13.63 20.187 13.437 19H10.571C10.369 20.186 9.941 21.619 8 21.619V23H16ZM17.127 12.438C21.192 11.091 23.628 7.105 24 3L19.924 2.999C19.888 3.482 19.844 3.954 19.785 4.404H22.473C22.046 6.405 20.924 9.134 18.009 10.655C17.723 11.293 17.424 11.886 17.127 12.438ZM10.777 5.652L8 6.056L10.0219 8.098L9.52734 11L12 9.61L14.4727 11L13.9781 8.098L16 6.056L13.223 5.652L12 3L10.777 5.652Z",
  fill: "url(#paint0_linear_20013992_47888)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20013992_47888",
  x1: 24,
  y1: 26.2083,
  x2: 2.3374,
  y2: -0.869919,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D36500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71875,
  stopColor: "#FFC42E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDF8D"
})));

function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.2dd6dfdaa6bbea400bf99835d0045c0c.svg";
export { ForwardRef as ReactComponent };